import { FunctionComponent, SVGProps } from "react";
import "./Option.css";

interface IStepProps {
  Image: FunctionComponent<SVGProps<SVGSVGElement>>;
  children: JSX.Element | string;
  href: string;
  active: boolean;
}

const Option = ({ Image, children, href, active }: IStepProps) => {
  return (
    <div className="optionContainer">
      <Image width={40} height={40} />
      <a href={href}>
        <p className={`optionText bold ${active ? "" : "grey"}`}>{children}</p>
      </a>
    </div>
  );
};

export { Option };
